// extracted by mini-css-extract-plugin
export default {"container":"app_container__69Ac9","bgContainer":"app_bgContainer__oaZ3H","orderStatus":"app_orderStatus__2EPEy"};